export default __webpack_public_path__ + "static/media/mgBedBank.ee9d284b.png";